import { render } from "./FormDropArea.vue?vue&type=template&id=0f99af56&scoped=true"
import script from "./FormDropArea.vue?vue&type=script&lang=js"
export * from "./FormDropArea.vue?vue&type=script&lang=js"

import "./FormDropArea.vue?vue&type=style&index=0&id=0f99af56&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f99af56"]])

export default __exports__